import React from "react";

import OfferCard, { ICardProps } from "@comparaonline/ui-offer-card";
import OfferCardList, { withSkeleton } from "@comparaonline/ui-offer-card-list";

import { useCardLayout } from "../CardOrientation";
import { Container } from "./Container";
import { LoadingBar } from "./LoadingBar";
import { applyPromotionToOffers } from "./helpers";

export * from "./useResultsProps";

const OfferCardListSkeleton = withSkeleton(OfferCardList);

export interface IProps {
  items: ICardProps[];
  isLoading: boolean;
}

export const ResultList: React.FC<IProps> = ({ items, isLoading }) => {
  const { Layout, Placeholder } = useCardLayout();
  const itemsWithPromotion = applyPromotionToOffers(items);

  const offers = React.useMemo(() => {
    return itemsWithPromotion.map(item => ({
      ...item,
      listAttributes: item.listAttributes.sort((a, b) => a.level - b.level)
    }));
  }, [itemsWithPromotion]);

  return (
    <Container>
      <LoadingBar loading={isLoading} />
      <OfferCardListSkeleton
        loading={isLoading}
        offers={offers}
        layout={Layout}
        skeletonComponent={Placeholder}
      >
        {(item: IProps["items"], index: number) => (
          <OfferCard
            layout={Layout}
            {...item}
            ctaProps={{ ...item.ctaProps, "data-index": index }}
          />
        )}
      </OfferCardListSkeleton>
    </Container>
  );
};
